import React from "react";

export const CardContent: React.FC<React.HTMLProps<HTMLDivElement>> = ({ children, className, ...props }) => (
    <div className={`p-4 ${className}`} {...props}>
        {children}
    </div>
);

export default CardContent;